import { render, staticRenderFns } from "./AgentClients.vue?vue&type=template&id=8fd08efc&"
import script from "./AgentClients.vue?vue&type=script&lang=js&"
export * from "./AgentClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports